import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'contains',
})
export class ContainsPipe implements PipeTransform {
  transform(value: string, text: string): boolean {
    return value.includes(text);
  }
}
